/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { translate, imagePrettyUrl } from 'gatsby-core-theme/src/helpers/getters';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import Link from 'gatsby-core-theme/src/hooks/link';
import { Context } from '~context/TranslationsProvider';
import styles from './providers-banner.module.scss';

const ProvidersBanner = ({ pageContext }) => {
  const { translations } = useContext(Context) || {};
  const providers = pageContext?.page?.relation?.providers;
  const featured = providers.filter((item) => item.featured !== 0);
  return (
    <div className={styles.providersBanner}>
      <h4>{translate(translations, 'our_partners', 'OUR PARTNERS')}</h4>
      <ul>
        {featured.length &&
          featured.map((item) => (
            <li key={item.id}>
              <Link to={item?.path} title={item?.name} className="provider-banner-gtm logo-cta">
                <LazyImage
                  src={imagePrettyUrl(item?.rectangle_logo)}
                  title={item?.name}
                  alt={item?.name}
                  height={35}
                />
              </Link>
            </li>
          ))}
      </ul>
    </div>
  );
};

ProvidersBanner.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      relation: PropTypes.shape({}),
    }),
  }).isRequired,
};

export default ProvidersBanner;
